import React from 'react';
import '../styles/Pages.css';

const TermsPage = () => (
  <div className="page-container">
    <div className="page-content">
      <h2>Terms &amp; Conditions</h2>
      <p className="event-description" style={{ marginBottom: '1.5rem' }}>
        Last updated: June 22, 2026
      </p>

      <div className="info-section">
        <h3>About This Service</h3>
        <p className="event-description">
          CanAm Games is a private, invitation-only website used to organize a personal backyard
          event. By submitting an RSVP or providing your contact information, you agree to these
          terms.
        </p>
      </div>

      <div className="info-section">
        <h3>SMS / Text Messaging Program</h3>
        <p className="event-description">
          By providing your mobile phone number, you consent to receive text messages about the
          event from the host. These messages may include invitations, RSVP confirmations,
          reminders, and event updates.
        </p>
        <ul className="event-highlights" style={{ marginTop: '1rem' }}>
          <li><strong>Message frequency varies</strong> based on event activity.</li>
          <li><strong>Message and data rates may apply</strong> per your mobile carrier plan.</li>
          <li>Reply <strong>STOP</strong> at any time to unsubscribe from text messages.</li>
          <li>Reply <strong>HELP</strong> for assistance.</li>
          <li>Carriers are not liable for delayed or undelivered messages.</li>
        </ul>
      </div>

      <div className="info-section">
        <h3>Your Information</h3>
        <p className="event-description">
          Information you provide is used only to coordinate this event and is handled as described
          in our <a href="/privacy">Privacy Policy</a>. We do not sell or share your information,
          including your phone number, with third parties.
        </p>
      </div>

      <div className="info-section">
        <h3>Contact</h3>
        <p className="event-description">
          Questions? Contact the host at{' '}
          <a href="mailto:alexfinley137@gmail.com">alexfinley137@gmail.com</a> or
          (716) 908-0639.
        </p>
      </div>
    </div>
  </div>
);

export default TermsPage;
